import { render, staticRenderFns } from "./TreeCollapse.vue?vue&type=template&id=65d89ecd&scoped=true"
import script from "./TreeCollapse.vue?vue&type=script&lang=js"
export * from "./TreeCollapse.vue?vue&type=script&lang=js"
import style0 from "./TreeCollapse.vue?vue&type=style&index=0&id=65d89ecd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d89ecd",
  null
  
)

export default component.exports